const BotIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        x={0}
        y={0}
        style={{
            enableBackground: 'new 0 0 15 15'
        }}
        viewBox="0 0 15 15"
        {...props}>
        <style>{'.st0{fill:#fff}'}</style>
        <path
            d="M10.3 5.7H4.8c-.9 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h5.5c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8zM5.6 8.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.5 1-1 1zm4 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.5 1-1 1zM6.5.8c.1 0 .1 0 .1-.1.1-.3.4-.5.9-.5.4 0 .7.2.9.5 0 .1.1.1.1.1.1 0 .1-.1.1-.1C8.5.3 8 0 7.6 0c-.5 0-1 .3-1.1.7-.1 0 0 .1 0 .1z"
            className="st0"
        />
        <path
            d="M13.4 5.4v-1c0-.4-.1-.9-.5-1.2-.3-.3-.7-.5-1.2-.5H8V1.9c.1-.1.3-.2.3-.5 0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7 0 .2.1.4.3.5v.7H3.5c-.5.2-.9.3-1.2.6s-.5.8-.5 1.2v1c-.7.2-1.2.8-1.2 1.5S1 8.2 1.7 8.5V10.8c0 .4.1.9.5 1.2.3.3.7.5 1.2.5h2.9c.2 0 .4-.1.4-.4 0-.1-.1-.3-.4-.3H3.5c-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7V4.4c0-.3.1-.5.3-.7s.4-.3.7-.3h8.2c.3 0 .5.1.7.3.2.2.3.4.3.7v3.7c0 .2.1.4.4.4h.2c.7-.2 1.2-.8 1.2-1.6-.1-.6-.5-1.2-1.1-1.5zM13 8.9c-.2 0-.4.1-.4.4v1.4c0 .1 0 .2-.1.3-.1.4-.4.5-.7.7-.1.1-2.7 1.3-3.7 1.9-.1-.1-.3-.1-.4-.1-.4 0-.8.4-.8.8s.4.7.8.7.8-.4.8-.8v-.1c1.1-.6 3.2-1.6 3.4-1.6.3-.1.7-.3.9-.5.3-.3.5-.7.5-1.1V9.3c.1-.3 0-.4-.3-.4z"
            className="st0"
        />
    </svg>
);
export default BotIcon;
